import { Component, Input, forwardRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as FileSaver from 'file-saver';

import { NotificationService } from '../../services/notification.service';
import { FileDataService, IFileInfo } from '../../services/file-data.service';

@Component({
  selector: 'renci-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true
    }
  ]
})
export class FileUploadComponent implements ControlValueAccessor {

  @Input() fileName = 'Choose file';

  file: { id, name };
  fileSize: number;
  fileCurrent: number;

  propagateChange = (_: any) => { };

  constructor(
    private notificationService: NotificationService,
    private dataService: FileDataService,
    private cdr: ChangeDetectorRef
  ) { }

  writeValue(value: any) {
    this.file = value;
    if (value) {
      this.fileName = value.name;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  upload(event: Event) {
    const input = event.srcElement as HTMLInputElement;
    if (input.files.length > 0) {
      const file = input.files.item(0);
      this.fileName = file.name;
      this.fileCurrent = undefined;

      this.dataService
        .uploadFile(file,
          (status) => {
            this.fileSize = status.total;
            this.fileCurrent = status.loaded;
          })
        .then(
          (res: IFileInfo) => {
            this.file = { id: res.fileId, name: file.name };
            this.propagateChange(this.file);
            this.fileCurrent = undefined;
            this.cdr.markForCheck();
          }, (error) => {
            this.file = null;
            this.propagateChange(this.file);
            this.cdr.markForCheck();
            this.notificationService.error(`Failed to upload ${file.name} file.`);
          });
    }
  }

  public download(event: Event) {
    event.preventDefault();
    this.dataService.downloadFile(this.file.id)
      .subscribe((result) => {
        if (result.type === HttpEventType.DownloadProgress) {
        } else if (result.type === HttpEventType.Response) {
          FileSaver.saveAs(result.body as Blob, this.fileName);
        }
      },
        error => {
          this.notificationService.error(`Failed to download ${this.fileName} file.`);
        });
  }
}
